import type { LocalStorageParams } from './localStorageKeys';

export const storageManager = () => {
	return {
		set<K extends keyof LocalStorageParams>(key: K, value: LocalStorageParams[K]) {
			const stringValue = JSON.stringify(value);
			window.localStorage.setItem(key, stringValue);
		},

		get<K extends keyof LocalStorageParams>(key: K): LocalStorageParams[K] | null {
			const raw = window.localStorage.getItem(key);
			if (!raw) return null;

			try {
				return JSON.parse(raw) as LocalStorageParams[K];
			} catch {
				return null;
			}
		},

		getOrDefault<K extends keyof LocalStorageParams>(key: K, defaultValue: LocalStorageParams[K]): LocalStorageParams[K] {
			const raw = window.localStorage.getItem(key);
			if (!raw) return defaultValue;

			try {
				return JSON.parse(raw) as LocalStorageParams[K];
			} catch {
				return defaultValue;
			}
		},

		remove<K extends keyof LocalStorageParams>(key: K) {
			window.localStorage.removeItem(key);
		},

		has<K extends keyof LocalStorageParams>(key: K): boolean {
			return window.localStorage.getItem(key) !== null;
		},
	};
};
